import { MAX_I32, SG_SMALLEST_ID } from '../util/numbers'
import { InferOutput, maxValue, minValue, nullable, number, optional, pipe } from 'valibot'

export const SgColumnIDSchema = pipe(number(), minValue(SG_SMALLEST_ID), maxValue(MAX_I32))
export const OptionalNullableSgColumnIDSchema = optional(nullable(SgColumnIDSchema))

export type SgColumnID = InferOutput<typeof SgColumnIDSchema>
